jQuery(function($){



	resizeWindow();
	$(window).resize(resizeWindow);
	$(window).on('load', resizeWindow);


	// home: faqs
	$('#home .faq .accordion .item .title').on('click tap', function() {
		$(this).toggleClass('open');
		$(this).next().slideToggle('fast');
	});

	// support: faqs
	$('#support .faq .accordion .item .title').on('click tap', function() {
		$(this).toggleClass('open');
		$(this).next().slideToggle('fast');
	});

	// support: video tabs
	$('#support .video .selector a').on('click tap', function(e) {
		e.preventDefault();
		e.stopPropagation();
        var rel = $(this).attr('rel');
        var img = $(this).attr('data-img');
		$('#support .video .selector a').removeClass('active');      
		$(this).addClass('active');
        $('#support .video a.play').removeClass('active');
        $('#support .video a.play.play-' + rel).addClass('active');
        $('#support .video').css('background-image', 'url(' + img + ')');
      console.log(img);console.log(rel);
	});

	// product: tabs
	$('#product .tabnav li a').on('click tap', function(e) {
		e.preventDefault();
		e.stopPropagation();
		$('#product .tabnav li a').removeClass('active');
		$(this).addClass('active');
		var rel = $(this).attr('rel');
		$('#product .tab').hide(0);
		$('#product .tab.tab-' + rel).show(0);
	});
  
    // product: switcher on mobile
    $('#product .switcher select').on('change', function() {
        var url = $(this).val();
        if (url) {
          	window.location = url;
        }
        return false;
    });
	
	// mobile nav
	$('.mobile_toggle').on('click tap', function() {
		if ($('#mobile_nav').hasClass('open')) {
			$('#mobile_nav').removeClass('open').fadeOut(300, function() {
				$(this).css('z-index', '-1');
				$('html,body').removeClass('locked');	
			});
		} else {
			$('#mobile_nav').css('z-index', '9998').fadeIn(300, function() {
				$(this).addClass('open');
				$('html,body').addClass('locked');	
			});
		}
	});	

	// inquire popup
    $('.toggle_inquire').on('click tap', function(e) {
        e.preventDefault();
        e.stopPropagation();
        $('html, body').addClass('frozen');
        $('#inquire').fadeIn(300);
    });
    $('#inquire .close').on('click tap', function() {
        $('#inquire').fadeOut(300, function() {
        	$('html, body').removeClass('frozen');
        });
    });  


    if(typeof window.IntersectionObserver !== 'undefined') {
      let options = {
        threshold: [0.5, 1]
      }
      const targets = document.querySelectorAll('.cb');
      const locker = document.querySelector('.locker__container');
      function handleIntersection(entries) {
        entries.map((entry) => {
          if (entry.isIntersecting) {
            entry.target.current = entry.target.dataset.swap;
            console.log(entry.target.current);
            document.querySelector(".locker__container ." + entry.target.current).classList.add("active");
          } else {
          	const container = document.querySelector(".locker__container ." + entry.target.current);
          	if(container){
	            container.classList.remove("active");
          	}
          }
        });
      }
      const observer = new IntersectionObserver(handleIntersection, options);
      targets.forEach(target => observer.observe(target));
    } else {
      // Fallback
    }

	const slider_titles = document.querySelectorAll('.leadproblem .slider .title.metropolis_semi')
	if(slider_titles){
		window.requestAnimationFrame(step);
	}

	function step(timeStamp) {
		window.requestAnimationFrame(step);
		
		let h = 0;
		
		slider_titles.forEach(function(element, index, array){
			element.style.height = '';
			h = Math.max(h, element.scrollHeight);
		});
		slider_titles.forEach(function(element, index, array){
			element.style.height = Math.ceil(h)+'px';
		});
	}
});

function resizeWindow() {
	var ww = $(window).width();
	/*var wh = $(window).height();*/

	// home: header
	if ($('#home').length) {
		var hh = $('#header').outerHeight();
		$('#home').css('margin-top', '-' + hh + 'px');
	}

	// home: filters
	if ($('#home .filters .slider').length) {
		$('#home .filters .slider').slick({
			dots: false,
			arrows: true,
			slidesToShow: 2,
			slidesToScroll: 1,
			adaptiveHeight: true,
			responsive: [
				{
					breakpoint: 1025,
					settings: "unslick"
				}
			]
		});
	}

	// home: blog
	if ($('#home .blog .slider, .leadproblem .slider').length) {
		$('#home .blog .slider, .leadproblem .slider').slick({
			dots: false,
			arrows: true,
			slidesToShow: 3,
			slidesToScroll: 1,
			adaptiveHeight: true,
			variableWidth: true,
			responsive: [
				{
					breakpoint: 1025,
					//settings: "unslick"
				}
			]
		});
		
		if (ww > 1024) {
			var bw = $('#home .blog').outerWidth();
			var bi = $('#home .blog .inner').outerWidth();
			var lw = $('#quality .leadproblem').outerWidth();
			var li = $('#quality .leadproblem .inner').outerWidth();
			if (bi < bw) {
				var diff = ( bw - bi ) / 2;
				$('#home .blog .slider').css('margin-right', '-' + diff + 'px');
			}
			if (li < lw) {
				var diff = ( lw - li ) / 2;
				$('#quality .leadproblem .slider').css('margin-right', '-' + diff + 'px');
			}
		}
	}

	// product: header
	if ($('#product').length) {
		var hh = $('#header').outerHeight();
		$('#product').css('margin-top', '-' + hh + 'px');
	}

	// quality: header
	if ($('#quality').length) {
		var hh = $('#header').outerHeight();
		if ($('#top').length) {
			var th = $('#top').outerHeight();
			hh = hh + th;
		}
		$('#quality').css('margin-top', '-' + hh + 'px');
	}
}